/* Crystal N Cuts — ring page additions (rings tagged jewelx-configurator).
   Everything here drives the ring page's EXISTING controls (carat tiles / carat select,
   colour + clarity selects, size modal, Add to Cart), so pricing and the cart flow are unchanged.
     A · carat panel   B · quality presets   C · guides (carat, colour & clarity, ring size)
     D · ship-by date  F · existing price box docked beside the description (desktop)
     G · 4 similar + 2 Signature rings                                                        */
(function () {
  if (window.__cncRing) return;
  window.__cncRing = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var num = function (v) { var n = Number(v); return isNaN(n) ? 0 : n; };
  var money = function (n) {
    var a = Math.round(Math.abs(n));
    return '$' + a.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  /* the ring's current total, as shown in the price box ("$948.00") */
  var totalNow = function () {
    var el = document.getElementById('jewelx-total-price');
    var n = el ? parseFloat((el.textContent || '').replace(/[^0-9.]/g, '')) : NaN;
    return isNaN(n) ? null : n;
  };
  var onTotalChange = function (fn) {
    var el = document.getElementById('jewelx-total-price');
    if (el) new MutationObserver(function () { fn(); }).observe(el, { childList: true, characterData: true, subtree: true });
  };
  var fire = function (el, type) { el.dispatchEvent(new Event(type, { bubbles: true })); };
  var later = function (fn) { setTimeout(fn, 0); };

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ───────────── A · carat panel ───────────── */
  function initCarat() {
    var panel = $('#CncCaratPanel'), trig = $('#CncCaratMore');
    if (!panel || !trig) return;
    var root = $('.jx4');
    var sel = $('#jx4-carat-more-select');
    var tiles = function () { return $$('.jx4-carat-tile'); };
    if (root) root.classList.add('cnc-enh');
    trig.hidden = false;

    function current() {
      var t = $('.jx4-carat-tile.active');
      if (t) return { v: t.getAttribute('data-carat'), p: num(t.getAttribute('data-price')), tile: true };
      if (sel && sel.value) {
        var o = sel.options[sel.selectedIndex];
        return { v: sel.value, p: num(o && o.getAttribute('data-price')), tile: false };
      }
      return { v: '', p: 0, tile: false };
    }
    function render() {
      var c = current(), tot = totalNow();
      $$('[data-cnc-carat]', panel).forEach(function (b) {
        var v = b.getAttribute('data-cnc-carat');
        var on = !!v && v === c.v;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var d = $('.cnc-cp-d', b);
        /* ring price with this size = today's total − current size's price + this size's price */
        if (d) d.textContent = tot === null ? '' : money(tot - c.p + num(b.getAttribute('data-price')));
      });
      var t = $('.cnc-carat-more__t', trig);
      if (c.v && !c.tile) { t.textContent = c.v.split('-')[0].trim() + ' ct'; trig.classList.add('has-value'); }
      else { t.textContent = 'More sizes'; trig.classList.remove('has-value'); }
    }
    function open(on) {
      panel.hidden = !on;
      trig.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) render();
    }
    function choose(v) {
      var tile = tiles().filter(function (b) { return b.getAttribute('data-carat') === v; })[0];
      if (tile) tile.click();
      else if (sel) {
        sel.value = v;
        if (sel.value === v) fire(sel, 'change');
      }
      later(render);
      open(false);
      trig.focus({ preventScroll: true });
    }
    trig.addEventListener('click', function () { open(panel.hidden); });
    panel.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cnc-carat]');
      if (b) choose(b.getAttribute('data-cnc-carat'));
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) { open(false); trig.focus(); } });
    if (sel) sel.addEventListener('change', function () { later(render); });
    tiles().forEach(function (b) { b.addEventListener('click', function () { later(render); }); });
    onTotalChange(function () { if (!panel.hidden) render(); });
    render();
  }

  /* ───────────── B · quality presets ───────────── */
  function initPresets() {
    var wrap = $('.cnc-presets');
    var cs = $('#jx4-color-select'), qs = $('#jx4-clarity-select');
    if (!wrap || !cs || !qs) return;
    var note = $('#CncPresetNote');
    var prem = function (sel, v) {
      var o = $$('option', sel).filter(function (x) { return x.value === v; })[0];
      return o ? num(o.getAttribute('data-premium')) : 0;
    };
    function sync() {
      var c = cs.value, q = qs.value, curP = prem(cs, c) + prem(qs, q), hit = null, tot = totalNow();
      $$('.cnc-preset', wrap).forEach(function (b) {
        var bc = b.getAttribute('data-color'), bq = b.getAttribute('data-clarity');
        var on = bc === c && bq === q;
        if (on) hit = b;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var d = $('.cnc-preset__d', b);
        if (d) d.textContent = tot === null ? '' : money(tot - curP + prem(cs, bc) + prem(qs, bq));
      });
      if (!note) return;
      if (hit) note.textContent = $('b', hit).textContent + ' selected · ' + c + ' · ' + q + '. You can still change colour and clarity below.';
      else if (c && q) note.textContent = 'Custom · ' + c + ' · ' + q + '. Pick a preset or keep your own.';
      else note.textContent = '';
    }
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('.cnc-preset');
      if (!b) return;
      cs.value = b.getAttribute('data-color'); fire(cs, 'change');
      qs.value = b.getAttribute('data-clarity'); fire(qs, 'change');
      later(sync);
    });
    onTotalChange(sync);
    cs.addEventListener('change', function () { later(sync); });
    qs.addEventListener('change', function () { later(sync); });
    sync();
    setTimeout(sync, 400);   /* after the page picks its default colour and clarity */
  }

  /* ───────────── C · guides ───────────── */
  var SHAPES = {   /* face-up length × width factors vs. a round of the same weight */
    round: [1, 1, 'round'], oval: [1.17, 0.83, 'oval'], pear: [1.2, 0.8, 'pear'], marquise: [1.55, 0.75, 'marquise'],
    emerald: [1.1, 0.78, 'step'], radiant: [1.05, 0.86, 'step'], 'long cushion': [1.15, 0.85, 'cushion'],
    cushion: [0.9, 0.9, 'cushion'], princess: [0.86, 0.86, 'square'], asscher: [0.86, 0.86, 'step'],
    heart: [1, 1, 'heart'], moval: [1.25, 0.8, 'oval'], trillian: [1.05, 1.05, 'tri'], baguette: [1.4, 0.6, 'step']
  };
  function shapeKey() {
    var t = (($('#jx4-shape-val') || {}).textContent || '').trim().toLowerCase();
    if (!t || t === '—' || t === '-') {
      var a = $('.jewelx-shape.active') || $('.jewelx-shape');
      t = a ? (a.getAttribute('data-shape') || '').toLowerCase() : 'round';
    }
    var keys = Object.keys(SHAPES).sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < keys.length; i++) if (t.indexOf(keys[i]) > -1) return { key: keys[i], name: t };
    return { key: 'round', name: t || 'round' };
  }
  function stoneSvg(kind, L, W, cx, cy) {
    var x = cx - W / 2, y = cy - L / 2, f = 'fill="#ffffff" stroke="#9a9489" stroke-width="1"';
    switch (kind) {
      case 'oval': return '<ellipse cx="' + cx + '" cy="' + cy + '" rx="' + W / 2 + '" ry="' + L / 2 + '" ' + f + '/>';
      case 'round': return '<circle cx="' + cx + '" cy="' + cy + '" r="' + W / 2 + '" ' + f + '/><circle cx="' + cx + '" cy="' + cy + '" r="' + W / 4.5 + '" fill="none" stroke="#d6cdbf" stroke-width=".8"/>';
      case 'square': return '<rect x="' + x + '" y="' + y + '" width="' + W + '" height="' + L + '" ' + f + '/><path d="M' + x + ' ' + y + 'L' + (x + W) + ' ' + (y + L) + 'M' + (x + W) + ' ' + y + 'L' + x + ' ' + (y + L) + '" stroke="#d6cdbf" stroke-width=".8"/>';
      case 'cushion': return '<rect x="' + x + '" y="' + y + '" width="' + W + '" height="' + L + '" rx="' + W * 0.28 + '" ' + f + '/>';
      case 'step': var c = Math.min(W, L) * 0.18;
        return '<polygon points="' + [x + c, y, x + W - c, y, x + W, y + c, x + W, y + L - c, x + W - c, y + L, x + c, y + L, x, y + L - c, x, y + c].join(' ') + '" ' + f + '/><rect x="' + (x + W * 0.25) + '" y="' + (y + L * 0.25) + '" width="' + W * 0.5 + '" height="' + L * 0.5 + '" fill="none" stroke="#d6cdbf" stroke-width=".8"/>';
      case 'pear': return '<path d="M' + cx + ' ' + y + ' C' + (x + W) + ' ' + (y + L * 0.45) + ',' + (x + W) + ' ' + (y + L) + ',' + cx + ' ' + (y + L) + ' C' + x + ' ' + (y + L) + ',' + x + ' ' + (y + L * 0.45) + ',' + cx + ' ' + y + 'Z" ' + f + '/>';
      case 'marquise': return '<path d="M' + cx + ' ' + y + ' Q' + (x + W * 1.15) + ' ' + cy + ',' + cx + ' ' + (y + L) + ' Q' + (x - W * 0.15) + ' ' + cy + ',' + cx + ' ' + y + 'Z" ' + f + '/>';
      case 'heart': return '<path d="M' + cx + ' ' + (y + L) + ' L' + x + ' ' + (y + L * 0.4) + ' A' + W / 4 + ' ' + W / 4 + ' 0 0 1 ' + cx + ' ' + (y + L * 0.22) + ' A' + W / 4 + ' ' + W / 4 + ' 0 0 1 ' + (x + W) + ' ' + (y + L * 0.4) + ' Z" ' + f + '/>';
      case 'tri': return '<polygon points="' + cx + ',' + y + ' ' + (x + W) + ',' + (y + L) + ' ' + x + ',' + (y + L) + '" ' + f + '/>';
    }
    return '';
  }
  function buildCaratChart() {
    var box = $('#CncFingers');
    if (!box) return;
    var chips = $$('#CncCaratPanel .cnc-cp-chip');
    var all = chips.map(function (b) { return b.getAttribute('data-cnc-carat'); });
    if (!all.length) all = ['0.50', '1.00', '1.50', '2.00', '3.00', '5.00'];
    var nums = all.map(function (v) { return parseFloat(v); }).filter(function (n) { return n > 0; });
    var want = [0.5, 1, 1.5, 2, 3, 5], pick = [];
    want.forEach(function (w) {
      var best = null;
      nums.forEach(function (n) { if (best === null || Math.abs(n - w) < Math.abs(best - w)) best = n; });
      if (best !== null && pick.indexOf(best) === -1) pick.push(best);
    });
    var curEl = $('.jx4-carat-tile.active');
    var sel = $('#jx4-carat-more-select');
    var cur = curEl ? parseFloat(curEl.getAttribute('data-carat')) : (sel && sel.value ? parseFloat(sel.value) : null);
    if (cur && pick.indexOf(cur) === -1) {
      var j = 0; pick.forEach(function (n, i) { if (Math.abs(n - cur) < Math.abs(pick[j] - cur)) j = i; });
      pick[j] = cur;
    }
    pick.sort(function (a, b) { return a - b; });
    var sh = shapeKey(), f = SHAPES[sh.key];
    var sub = $('#CncCaratSub');
    if (sub) sub.textContent = sh.name.charAt(0).toUpperCase() + sh.name.slice(1) + ' shape, drawn to scale on a size 6 finger (16.5 mm wide). Sizes are approximate face-up measurements.';
    var sc = 4.1, fw = 16.5 * sc, fx = (90 - fw) / 2;
    box.innerHTML = pick.map(function (ct) {
      var d = 6.5 * Math.cbrt(ct), L = d * f[0], W = d * f[1];
      var mm = f[2] === 'round' ? d.toFixed(1) + ' mm' : L.toFixed(1) + ' × ' + W.toFixed(1) + ' mm';
      return '<div class="cnc-finger' + (cur && Math.abs(ct - cur) < 0.001 ? ' is-on' : '') + '">' +
        '<svg viewBox="0 0 90 150" role="img" aria-label="' + ct.toFixed(2) + ' carat on a finger">' +
        '<rect x="' + fx + '" y="4" width="' + fw + '" height="170" rx="' + fw / 2 + '" fill="#efd9c8"/>' +
        '<rect x="' + fx + '" y="98" width="' + fw + '" height="8" fill="#d8b46a"/>' +
        stoneSvg(f[2], L * sc, W * sc, 45, 102) + '</svg>' +
        '<b>' + ct.toFixed(2) + ' ct</b><span>≈ ' + mm + '</span></div>';
    }).join('');
  }
  function gem(fill, dots) {
    var s = '';
    for (var i = 0; i < dots; i++) {
      var a = i * 2.4, r = 6 + (i % 3) * 5;
      s += '<circle cx="' + (30 + Math.cos(a) * r).toFixed(1) + '" cy="' + (30 + Math.sin(a) * r).toFixed(1) + '" r="' + (1 + (i % 2) * 0.6) + '" fill="#4a4a46"/>';
    }
    return '<svg viewBox="0 0 60 60" aria-hidden="true"><polygon points="30,4 54,22 30,56 6,22" fill="' + fill + '" stroke="#b8ae9f" stroke-width="1.2"/><polyline points="6,22 54,22" stroke="#d6cdbf" stroke-width="1" fill="none"/>' + s + '</svg>';
  }
  function buildQualityChart() {
    var col = $('#CncColScale'), cla = $('#CncClaScale');
    if (!col || col.childElementCount) return;
    var cur = (($('#jx4-color-select') || {}).value || ''), curQ = (($('#jx4-clarity-select') || {}).value || '');
    var cols = [['D', '#ffffff'], ['E', '#fefefd'], ['F', '#fdfcf8'], ['G', '#fcf9ef'], ['H', '#fbf6e6'], ['I', '#faf2da'], ['J', '#f8edca'], ['K', '#f6e7b9'], ['L', '#f3e0a6'], ['M', '#efd892']];
    col.innerHTML = cols.map(function (c) { return '<div' + (c[0] === cur ? ' class="is-mark"' : '') + '>' + gem(c[1], 0) + c[0] + '</div>'; }).join('');
    var cl = [['FL', 0], ['IF', 0], ['VVS1', 1], ['VVS2', 2], ['VS1', 3], ['VS2', 4], ['SI1', 6], ['SI2', 8], ['I1', 11]];
    cla.innerHTML = cl.map(function (c) { return '<div' + (c[0] === curQ ? ' class="is-mark"' : '') + '>' + gem('#ffffff', c[1]) + c[0] + '</div>'; }).join('');
  }
  function initGuides() {
    var guides = $$('.cnc-gd');
    if (!guides.length) return;
    guides.forEach(function (g) { document.body.appendChild(g); });   /* escape any transformed parent */
    var last = null;
    function close(g) {
      g.hidden = true;
      document.body.style.overflow = '';
      if (last) { try { last.focus({ preventScroll: true }); } catch (e) {} }
    }
    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-cnc-open]');
      if (o) {
        var g = document.getElementById('CncGuide-' + o.getAttribute('data-cnc-open'));
        if (!g) return;
        e.preventDefault();
        last = o;
        if (g.id === 'CncGuide-carat') buildCaratChart();
        if (g.id === 'CncGuide-quality') { $('#CncColScale').innerHTML = ''; buildQualityChart(); }
        /* the ring-size picker is a modal too — let the guide sit on top of it */
        g.hidden = false;
        document.body.style.overflow = 'hidden';
        var x = $('.cnc-gd__x', g); if (x) x.focus({ preventScroll: true });
        return;
      }
      var gd = e.target.closest('.cnc-gd');
      if (gd && (e.target === gd || e.target.closest('[data-cnc-close]'))) close(gd);
      var tab = e.target.closest('[data-cnc-tab]');
      if (tab) {
        var box = tab.closest('.cnc-gd__box');
        $$('[data-cnc-tab]', box).forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
        $$('[data-cnc-pane]', box).forEach(function (p) { p.hidden = p.getAttribute('data-cnc-pane') !== tab.getAttribute('data-cnc-tab'); });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      guides.forEach(function (g) { if (!g.hidden) close(g); });
    });
  }

  /* ───────────── D · ship-by date ───────────── */
  function initShip() {
    var cfg = $('#CncShipCfg');
    if (!cfg) return;
    var make = num(cfg.getAttribute('data-make')) || 10, ship = num(cfg.getAttribute('data-ship'));
    var cut = num(cfg.getAttribute('data-cut')), sat = cfg.getAttribute('data-sat') === '1';
    var closed = (cfg.getAttribute('data-closed') || '').split(/[\s,]+/).filter(Boolean);
    var iso = function (d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); };
    var work = function (d) { var w = d.getDay(); return !(w === 0 || (w === 6 && !sat) || closed.indexOf(iso(d)) > -1); };
    function add(start, n) {
      var d = new Date(start.getTime()), c = 0, guard = 0;
      while (c < n && guard < 400) { d.setDate(d.getDate() + 1); guard++; if (work(d)) c++; }
      return d;
    }
    var fmt = function (d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); };
    var now = new Date(), start = new Date(now.getTime());
    if (now.getHours() >= cut) start.setDate(start.getDate() + 1);   /* after cut-off: counting starts tomorrow */
    var shipBy = add(start, make);
    var a1 = add(shipBy, Math.max(ship, 1)), a2 = add(shipBy, ship + 2);
    $$('[data-cnc-ship]').forEach(function (el) { el.textContent = fmt(shipBy); });
    $$('[data-cnc-deliv]').forEach(function (el) { el.textContent = fmt(a1) + ' – ' + fmt(a2); });
  }

  /* ───────────── F · dock the existing price box beside the description (desktop) ───────────── */
  function initDock() {
    var grid = $('.cnc-pd');
    var slot = $('#CncBarSlot'), bar = $('#CncBar');
    var info = grid && $('.product__info-wrapper', grid);
    var extra = grid && $('.cnc-pd-extra', grid);
    if (!grid || !slot || !bar || !info || !extra) return;
    var sel = $('#CncDockSel');
    var mq = window.matchMedia('(min-width: 990px)');
    var docked = false, barH = 0, ticking = false;

    function txt(id) { var e = document.getElementById(id); var t = e ? e.textContent.trim() : ''; return t === '—' || t === '-' ? '' : t; }
    function fill() {
      if (!sel) return;
      var rows = [];
      var shape = txt('jx4-shape-val'); if (shape) rows.push(['Shape', shape]);
      var metal = txt('jx4-metal-val'); if (metal) rows.push(['Metal', metal]);
      var carat = txt('jx4-carat-val'); if (carat) rows.push(['Carat', carat.split('-')[0].trim() + ' ct']);
      var c = txt('jx4-color-val'), q = txt('jx4-clarity-val');
      if (c || q) rows.push(['Quality', [c, q].filter(Boolean).join(' · ')]);
      var size = txt('jx4-size-val');
      rows.push(['Ring size', size ? (size === 'Size Later' ? 'Size later' : size) : '']);
      sel.innerHTML = rows.map(function (r) {
        var v = r[1] ? r[1].replace(/[<>&]/g, '') : '<button type="button" data-cnc-pick-size>Choose size</button>';
        return '<dt>' + r[0] + '</dt><dd>' + v + '</dd>';
      }).join('');
    }
    sel && sel.addEventListener('click', function (e) {
      if (!e.target.closest('[data-cnc-pick-size]')) return;
      var t = $('#jx4-size-trigger'); if (t) t.click();
    });
    ['jx4-shape-val', 'jx4-metal-val', 'jx4-carat-val', 'jx4-color-val', 'jx4-clarity-val', 'jx4-size-val', 'jx4-summary'].forEach(function (id) {
      var e = document.getElementById(id);
      if (e) new MutationObserver(fill).observe(e, { childList: true, characterData: true, subtree: true });
    });
    fill();

    function headerOffset() {
      var h = $('.shopify-section-header-sticky') || $('sticky-header') || $('.section-header');
      if (!h) return 0;
      var r = h.getBoundingClientRect();
      return r.bottom > 0 && r.top <= 0.5 ? r.bottom : 0;
    }
    function undock() {
      if (!docked) return;
      docked = false;
      bar.classList.remove('is-docked');
      bar.style.left = bar.style.top = bar.style.width = '';
      slot.classList.remove('is-docking');
      slot.style.height = '';
    }
    function update() {
      ticking = false;
      if (!mq.matches) { undock(); return; }
      var top = headerOffset() + 16;
      var slotR = (docked ? slot : bar).getBoundingClientRect();   /* the slot is display:contents until docking */
      var extraR = extra.getBoundingClientRect();
      var infoR = info.getBoundingClientRect();
      var infoBottom = infoR.bottom;
      /* dock once the box has scrolled above the top AND there is reading content (left) still below */
      var should = slotR.bottom < top && extraR.bottom > top + 160 && extraR.bottom > infoBottom;
      if (!should) { undock(); return; }
      if (!docked) {
        barH = bar.offsetHeight;
        slot.style.height = barH + 'px';
        slot.classList.add('is-docking');
        bar.classList.add('is-docked');
        docked = true;
      }
      var pad = parseFloat(getComputedStyle(info).paddingLeft) || 0;
      var h = bar.offsetHeight;
      var gridBottom = Math.max(extraR.bottom, infoBottom);
      bar.style.left = (infoR.left + pad) + 'px';
      bar.style.width = Math.max(240, infoR.width - pad) + 'px';
      bar.style.top = Math.min(top, gridBottom - h - 8) + 'px';
    }
    var req = function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', req);
    if (mq.addEventListener) mq.addEventListener('change', req);
    req();

    /* Add to Cart from the docked box: if an option is still missing, scroll up to the message */
    var cta = $('#jewelx-request-btn');
    cta && cta.addEventListener('click', function () {
      if (!docked) return;
      setTimeout(function () {
        var v = $('#jewelx-validation-message');
        if (v && v.classList.contains('show')) {
          var y = v.getBoundingClientRect().top + window.pageYOffset - 140;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 80);
    });
  }

  /* ───────────── G · 4 similar + 2 Signature ───────────── */
  function initRecs() {
    var box = $('#CncRecs');
    if (!box) return;
    document.documentElement.classList.add('cnc-recs-on');
    var list = $('[data-cnc-sim]', box);
    var n = num(box.getAttribute('data-n')) || 4;
    var skip = [];
    try { skip = JSON.parse(($('[data-cnc-sig-ids]', box) || {}).textContent || '[]').map(String); } catch (e) {}
    var hasSig = !!$('.cnc-sig', box);
    function giveUp() {
      if (hasSig) { if (list) list.remove(); return; }
      box.remove();
      document.documentElement.classList.remove('cnc-recs-on');
    }
    function load() {
      fetch(box.getAttribute('data-url'))
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var items = $$('.cnc-recs__item', doc).filter(function (li) { return skip.indexOf(String(li.getAttribute('data-pid'))) === -1; }).slice(0, n);
          if (!items.length) { giveUp(); return; }
          list.innerHTML = '';
          items.forEach(function (li) { list.appendChild(document.importNode(li, true)); });
          /* product-card swatches script (inline <script> tags don't run when inserted) */
          if (!window.__cncCardSwatches) {
            var src = $('script[src*="cnc-card.js"]', doc);
            if (src) { var s = document.createElement('script'); s.src = src.getAttribute('src'); s.defer = true; document.head.appendChild(s); }
          }
        })
        .catch(giveUp);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); }
      }, { rootMargin: '600px 0px' });
      io.observe(box);
    } else load();
  }

  ready(function () {
    [initCarat, initPresets, initGuides, initShip, initDock, initRecs].forEach(function (fn) {
      try { fn(); } catch (e) { if (window.console) console.warn('[cnc-ring]', fn.name, e); }
    });
  });
})();
